'use client'

import { useQuery } from '@tanstack/react-query'
import { revalidatePath } from '@/lib/actions'
import { getKotPrinterType } from '@/lib/actions/register/get-kot-printer-type'
import { useKotPrinter } from '@/lib/hooks'

import { ScrollArea } from '@/components/ui'
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer'
import { KotCard, KotItem } from '@/components/molecules'

interface KotListProps extends React.ComponentPropsWithoutRef<'div'> {
  orders?: any
}

export const KotList = ({ orders }: KotListProps) => {
  const { requestPrinter, printer, printReceipt } = useKotPrinter()

  const { data } = useQuery({
    queryKey: ['kot-printer-type'],
    queryFn: () => getKotPrinterType(),
  })

  return (
    <ScrollArea className="h-[var(--inner-layout-height)] w-full">
      <div className="grid w-full flex-col gap-4 pr-4 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
        {orders?.map((order: any, index: number) => {
          return (
            <Drawer
              key={index}
              onOpenChange={async (isOpen) => {
                if (!isOpen) {
                  await revalidatePath('/kot')
                }
              }}
            >
              <DrawerTrigger className="flex w-full" asChild>
                <KotItem
                  order={order}
                  printReceipt={printReceipt}
                  requestPrinter={requestPrinter}
                  printer={printer}
                  printerType={data?.kotPrinterType}
                />
              </DrawerTrigger>
              <DrawerContent className="w-[90svw] max-w-[360px] md:w-[80svw] md:max-w-[500px] lg:max-w-[900px]">
                <DrawerTitle className="hidden">
                  Order Details {order?.cart?.id}
                </DrawerTitle>
                <DrawerDescription className="hidden" />
                <KotCard order={order} />
              </DrawerContent>
            </Drawer>
          )
        })}
      </div>
    </ScrollArea>
  )
}
